import { useApplication } from '@/hooks/useApplication';
import { queueMessageUtil } from '@/util/validation/queuemessage';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { FC } from 'react';
import { ParamProps } from './ParamRenderer';

const ParamMessageQueue: FC<ParamProps> = (props) => {
  const { application } = useApplication();

  const initialValue = queueMessageUtil().getValue(props.configuration, props.initialValue);

  const handleChange = (e: SelectChangeEvent<any>) => {
    props.onChange([props.configuration.value, e.target.value]);
  };

  return (
    <FormControl fullWidth size='small' required={props.configuration.required}>
      <InputLabel id='select-queue-label'>{props.configuration.label}</InputLabel>
      <Select
        labelId='select-queue-label'
        id='select-queue'
        value={initialValue?.value || ''}
        label={props.configuration.label}
        onChange={handleChange}
        required={props.configuration.required}
        error={!!props.errors?.length}
      >
        {application.queues
          ?.find((queue) => queue.queue === initialValue?.type)
          ?.messages.map((message) => (
            <MenuItem value={message}>{message}</MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
export default ParamMessageQueue;
